// Labels and official help links for the form-based marketing template builder.
const root = 'https://developers.facebook.com/documentation/business-messaging/whatsapp/';

export const MARKETING_PRESETS = {
  custom: { label: 'Custom message', docs: `${root}templates/marketing-templates/custom-marketing-templates/` },
  coupon: { label: 'Coupon code', docs: `${root}templates/marketing-templates/coupon-templates/` },
  limited_offer: { label: 'Limited-time offer', docs: `${root}templates/marketing-templates/limited-time-offer-templates/` },
  location: { label: 'Location', docs: `${root}templates/marketing-templates/location-templates/` },
  media_carousel: { label: 'Media card carousel', docs: `${root}templates/marketing-templates/media-card-carousel-templates/` },
  call_permission: { label: 'Call permission request', docs: `${root}templates/marketing-templates/call-permission-request-message-template/` },
  catalog: { label: 'Catalog', docs: `${root}catalogs/catalog-template-messages` },
  multi_product: { label: 'Multi-product message', docs: `${root}catalogs/mpm-template-messages` },
  product_carousel: { label: 'Product card carousel', docs: `${root}catalogs/product-card-carousel-template-messages` },
  single_product: { label: 'Single-product message', docs: `${root}catalogs/spm-template-messages` },
};
